import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import debounce from "lodash/debounce";
import { AccountStorage, Account } from "@services/account";
var accountStorage = new AccountStorage();
var account = new Account();
var handler;
export default {
  data: function data() {
    return {
      keepFirst: true,
      selected: null,
      isFetching: false,
      userInfoArr: [{
        id: 1,
        icon: require("./images/icon_01.png"),
        title: "购物车",
        path: "/cart/cartList",
        flag: this.$route.path === "/cart/cartList"
      }, {
        id: 2,
        icon: require("./images/icon_02.png"),
        title: "订单",
        path: "/user-center/order/0"
      }],
      searchKey: "",
      searchList: [],
      hoverIdex: -1,
      isShowSearchWrap: false,
      isHistory: false,
      lenovoSearchList: [],
      carNum: [],
      isHover: false,
      cartList: [],
      productId: [],
      isLogin: false,
      cartSum: "",
      loading: false,
      appId: 1,
      // 判断是App还是商城
      isRead: {},
      index: -1,
      searchValue: "",
      isExternal: false,
      jiedanData: null,
      //截单数据
      userInfo: accountStorage.getCacheUserInfo()
    };
  },
  props: {
    headerTit: {
      //头部标题 无时可省略
      type: String,
      default: ""
    },
    inputWidth: {
      //只是搜索文本框的宽 不算按钮宽度
      type: [Number, String],
      default: 483
    }
  },
  computed: {
    searchWrapWidth: function searchWrapWidth() {
      return Number(this.inputWidth) + 82;
    },
    flag: function flag() {
      return this.$route.path === "/cart/cartList";
    },
    isMyAccount: function isMyAccount() {
      return this.$route.path === "/user-center/my-account";
    },
    activeNum: function activeNum() {
      return this.$root.CurrentMonthStatistics.activityCount || 0;
    }
  },
  filters: {
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      return y + "-" + MM;
    }
  },
  mounted: function mounted() {
    this.getIsRead();
    if (this.userInfo) {
      this.isExternal = this.userInfo.type == 1 ? true : false;
    }
    this.getJieDan();
  },
  watch: {
    searchKey: {
      immediate: true,
      deep: true,
      handler: function handler(val) {
        return this.searchValue = val;
      }
    },
    $route: {
      deep: true,
      handler: function handler(val) {
        this.searchKey = val.params.name;
      }
    }
  },
  methods: {
    //获取是否截单
    getJieDan: function getJieDan() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var api, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.userInfo) {
                _context.next = 6;
                break;
              }
              api = "/pjyy-deepexi-user-center/api/v1/customer/manager/getSendTimeByVencusNo?userCode=".concat(_this.userInfo.account);
              _context.next = 4;
              return _this.$getHttpClient().post(api);
            case 4:
              res = _context.sent;
              if (res.data.code == 200) {
                _this.jiedanData = res.data.data;
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //关闭截单提示
    closeJiedan: function closeJiedan() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var api, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              api = "/pjyy-deepexi-user-center/api/v1/customer/manager/cancelSendTime?userCode=".concat(_this2.userInfo.account);
              _context2.next = 3;
              return _this2.$getHttpClient().post(api);
            case 3:
              res = _context2.sent;
              if (res.data.code == 200) {
                _this2.jiedanData = res.data.data;
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    specialCharacters: function specialCharacters(string) {
      if (string == undefined) {
        return;
      }
      return string.replace(/[`~!@#$%^&*_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*——\-+={}|《》？：“”【】、；‘’，。、]/g, "");
    },
    // 获取公司账号
    getAccount: function getAccount() {
      if (this.userInfo) {
        return this.userInfo.loginCompanyAccount;
      }
      return;
    },
    // 查看未读消息
    getIsRead: function getIsRead() {
      var _this3 = this;
      var url = "/xpaas-message-center/api/v1/message/pm/pool/isRead?appId=".concat(this.appId, "&userId=").concat(Number(this.getUserId()), "&loginCompanyAccount=").concat(Number(this.getAccount()));
      this.$getHttpClient().get(url).then(function (res) {
        if (res.data.code === 200) {
          _this3.isRead = res.data.data;
        }
      });
    },
    getSum: function getSum() {
      var _this4 = this;
      var url = "/pjyy-deepexi-order-center/api/v1/cart/cartListNumber?userId=".concat(this.getUserId());
      this.$getHttpClient({}).get(url).then(function (res) {
        _this4.cartSum = res.data.data;
      });
    },
    // 获取参与活动统计数据
    getNum: function getNum() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!accountStorage.getCacheUserInfo()) {
                _context3.next = 5;
                break;
              }
              _context3.next = 3;
              return _this5.$getHttpClient().get(
              // "/pjyy-deepexi-user-center/api/v1/balance/getCurrentMonthStatistics"
              "/pjyy-deepexi-user-center/api/v1/balance/getMonthStatistics");
            case 3:
              result = _context3.sent;
              if (result.data.code === "200") {
                _this5.$root.CurrentMonthStatistics = result.data.data;
              }
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    //获取用户ID
    getUserId: function getUserId() {
      if (this.userInfo) {
        return this.userInfo.userId;
      }
      return;
    },
    //购物车商品列表接口数据
    cartListDataSource: function cartListDataSource() {
      var _this6 = this;
      this.loading = true;
      // let _default = {
      //   userId: Number(this.getUserId())
      // };
      var url = "/pjyy-deepexi-order-center/api/v1/cart/findCartList";
      this.$getHttpClient({
        useResponseRedirectLogin: false,
        useSpinner: false
      }).post(url).then(function (res) {
        if (res.data.code === "401") {
          return;
        }
        if (res.data.code === "200") {
          if (res.data.data) {
            _this6.loading = false;
            _this6.cartList = res.data.data && res.data.data.ocCartLists;
            res.data.data.ocCartLists.forEach(function (ele) {
              _this6.carNum.push(ele.totalNumber);
            });
          }
        }
      }).finally(function () {
        _this6.loading = false;
      });
    },
    //删除历史记录
    delHistory: function delHistory() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var URL;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              URL = "/pjyy-deepexi-product-center/api/v1/product/PcProduct/deleteHistory";
              _context4.next = 3;
              return _this7.$getHttpClient({
                useSpinner: false
              }).get(URL);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    goIndex: function goIndex() {
      this.$router.push({
        path: "/"
      });
    },
    clickSearchHistory: function clickSearchHistory(value) {
      this.searchKey = value;
      this.onSearch(value);
    },
    clickSearchKey: function clickSearchKey(item) {
      this.searchKey = item.value;
      this.onSearch(item.value);
      // this.$router.push({
      //   name: "details",
      //   params: {
      //     id: item.key
      //   }
      // });
      // this.isShowSearchWrap = false;
    },
    onBlur: function onBlur() {
      var _this8 = this;
      setTimeout(function () {
        document.removeEventListener("keydown", handler, false);
        _this8.index = -1;
        _this8.isShowSearchWrap = false;
      }, 1000);
    },
    getAsyncData: debounce( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            this.index = -1;
            this.isFetching = true;
            if (this.searchKey.length) {
              _context5.next = 7;
              break;
            }
            _context5.next = 5;
            return this.searchHistory();
          case 5:
            _context5.next = 9;
            break;
          case 7:
            _context5.next = 9;
            return this.lenovoSearch(this.searchKey);
          case 9:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    })), 500),
    debounces: function debounces(func, delay) {
      var timeout;
      return function () {
        var context = this;
        var args = arguments;
        // && 短路运算 == if(timeout) else {...}
        timeout && clearTimeout(timeout);
        timeout = setTimeout(function () {
          func.apply(context, args);
        }, delay);
      };
    },
    //联想搜索
    lenovoSearch: function lenovoSearch(searchKey) {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var key, URL, result, resultList;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              key = _this9.specialCharacters(searchKey);
              URL = "/pjyy-deepexi-product-center/api/v1/product/PcProduct/lenovoSearch?name=".concat(key);
              _context6.next = 4;
              return _this9.$getHttpClient({
                useSpinner: false
              }).get(URL);
            case 4:
              result = _context6.sent;
              _this9.isFetching = false;
              resultList = result.data.data;
              _this9.searchList = [];
              if (resultList.length > 0) {
                _this9.isShowSearchWrap = true;
                _this9.isHistory = false;
                _this9.lenovoSearchList = resultList;
                resultList.forEach(function (element) {
                  _this9.searchList.push(element.value);
                });
                document.removeEventListener("keydown", _this9.handler, false);
                document.addEventListener("keydown", _this9.handler, false);
                _this9.index = -1;
              } else {
                _this9.isShowSearchWrap = false;
              }
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    handler: function handler(e) {
      var _this10 = this;
      if (this.isHistory) {
        if (e.keyCode == 38) {
          if (this.index > 0) {
            this.index--;
          } else {
            this.index = this.searchList.length;
          }
        } else if (e.keyCode == 40) {
          if (this.index < this.searchList.length) {
            this.index += 1;
          } else {
            this.index = 0;
          }
        } else if (e.keyCode == 13) {
          this.searchKey = this.searchList[this.index];
          document.removeEventListener("keydown", this.handler, false);
          this.onSearch(this.searchKey);
        }
      } else if (!this.isHistory) {
        if (e.keyCode == 38) {
          if (this.index > 0) {
            this.index--;
          } else {
            this.index = this.lenovoSearchList.length;
          }
        } else if (e.keyCode == 40) {
          if (this.index < this.lenovoSearchList.length) {
            this.index += 1;
          } else {
            this.index = 0;
          }
        } else if (e.keyCode == 13) {
          if (this.index == -1) {
            this.$nextTick(function () {
              // this.onSearch(this.searchKey);
              _this10.debounces(_this10.onSearch(_this10.searchKey), 300);
            });
          } else {
            this.searchKey = this.lenovoSearchList[this.index].value;
            this.onSearch(this.searchKey);
          }
          document.removeEventListener("keydown", this.handler, false);
        }
      }
    },
    //历史搜索
    searchHistory: function searchHistory() {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var URL, result, resultList;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              URL = "/pjyy-deepexi-product-center/api/v1/product/PcProduct/searchHistory";
              _context7.next = 3;
              return _this11.$getHttpClient({
                useSpinner: false
              }).get(URL);
            case 3:
              result = _context7.sent;
              _this11.isFetching = false;
              resultList = result.data.data;
              _this11.searchList = [];
              _this11.isHistory = true;
              if (resultList) {
                if (resultList.length > 0) {
                  _this11.isShowSearchWrap = true;
                  _this11.searchList = resultList;
                  document.removeEventListener("keydown", _this11.handler, false);
                  document.addEventListener("keydown", _this11.handler, false);
                  _this11.index = -1;
                } else {
                  _this11.isShowSearchWrap = false;
                }
              }
            case 9:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    onMouseOver: function onMouseOver(idx) {
      this.hoverIdex = idx;
    },
    onSearch: function onSearch(value) {
      this.isShowSearchWrap = false;
      value = this.specialCharacters(value);
      value = value.trim();
      if (value) {
        this.$router.push({
          name: "search-detail",
          params: {
            name: value
          }
        });
        this.searchKey = this.searchValue;
      }
    },
    getSeatchWidth: function getSeatchWidth() {
      return this.inputWidth + 82;
    },
    onMouseIn: function onMouseIn(event) {
      if (this.cartSum === 0 || this.isExternal) {
        event.stopPropagation();
        this.isHover = false;
      } else {
        this.isLogin = account.isLogined();
        if (this.isLogin) {
          event.stopPropagation();
          this.cartListDataSource();
          this.isHover = true;
        }
      }
    },
    onMouseOut: function onMouseOut(event) {
      event.stopPropagation();
      this.isHover = false;
    },
    // 清空
    handleEmpty: function handleEmpty() {
      var _this12 = this;
      // if (!this.flag) {
      var productId = [];
      var url = "/pjyy-deepexi-order-center/api/v1/cart/removeCartList";
      this.cartList.forEach(function (item) {
        productId.push(item.productId);
      });
      var data = {
        productId: productId,
        userId: this.getUserId()
      };
      this.$getHttpClient({
        // useResponseRedirectLogin: true,
        // useSpinner: true
      }).post(url, data).then(function (res) {
        if (res.data.code === "200") {
          _this12.$buefy.toast.open({
            message: "清空商品成功",
            type: "is-success"
          });
          _this12.carNum = [];
          _this12.getSum();
          _this12.cartListDataSource();
        }
      });
      // } else {
      // this.$emit("handleEmpty");
      // }
    },
    // 删除
    handleDelete: function handleDelete(productId) {
      var _this13 = this;
      if (!this.flag) {
        this.loading = true;
        this.carNum = [];
        this.productId = [productId];
        var url = "/pjyy-deepexi-order-center/api/v1/cart/removeCartList";
        var data = {
          productId: this.productId,
          userId: this.getUserId()
        };
        this.$getHttpClient().post(url, data).then(function (res) {
          if (res.data.code === "200") {
            _this13.$buefy.toast.open({
              message: "删除成功",
              type: "is-success"
            });
            _this13.loading = false;
            _this13.getSum();
            _this13.cartListDataSource();
          }
        }).finally(function () {
          _this13.loading = false;
        });
      } else {
        this.$emit("handleDelete", productId);
      }
    },
    goCartLink: function goCartLink() {
      if (this.isExternal) {
        this.$buefy.toast.open({
          message: "您尚未成为正式会员，无法进入该页面",
          type: "is-danger"
        });
        this.$router.push({
          path: '/'
        });
        return;
      }
      this.$router.push({
        path: "/cart/cartList"
      });
    },
    goodsLink: function goodsLink() {
      if (this.isExternal) {
        this.$buefy.toast.open({
          message: "您尚未成为正式会员，无法进入该页面",
          type: "is-danger"
        });
        this.$router.push({
          path: '/'
        });
        return;
      }
      this.$router.push({
        path: "/user-center/order/0"
      });
    },
    goodsLinkMessage: function goodsLinkMessage() {
      if (this.isExternal) {
        this.$buefy.toast.open({
          message: "您尚未成为正式会员，无法进入该页面",
          type: "is-danger"
        });
        this.$router.push({
          path: '/'
        });
        return;
      }
      this.$router.push({
        name: "messageCenterList",
        params: {}
      });
    },
    goodsLinkEnshrine: function goodsLinkEnshrine() {
      if (this.isExternal) {
        this.$buefy.toast.open({
          message: "您尚未成为正式会员，无法进入该页面",
          type: "is-danger"
        });
        this.$router.push({
          path: '/'
        });
        return;
      }
      this.$router.push({
        name: "enshrine"
      });
    }
  },
  created: function created() {
    this.isLogin = account.isLogined();
    if (this.isLogin) {
      this.getSum();
      this.getNum();
    }
    var route = this.$route;
    if (route.name === "search-detail" || route.name === "details") {
      if (route.params && {}.toString.call(route.params.name) === "[object String]") {
        if (route.params.name === "null") {
          this.searchKey = "";
        } else {
          this.searchKey = route.params.name;
        }
      }
    }
  }
};